import NodeAuth from "node-auth-api";

import * as types from "../reducers/UserReducer";
import { defaultDelay } from "../../config";
import { setTickets } from "./TicketsActions";

export function login(email, password, done) {
  return dispatch => {
    dispatch(_userLoading());
    setTimeout(() => {
      NodeAuth.User.login(email, password, { disableOperations: true })
        .then(res => {
          if(res.success) {
            console.log(res);
            done();
            dispatch(_userLoggedIn(res.data));
          } else {
            if(typeof res.data.message === "string")
              return dispatch(_userErrors([res.data.message]));
            if(typeof res.data.message === "object" && res.data.message.code)
              return dispatch(_userErrors(["Unauthorized access, try clear your local storage"]))
            
            return dispatch(_userErrors(["Something went wrong!"]));
          }
        })
        .catch(err => {
          console.error(err);
          dispatch(_userErrors(["Unexpected error occured during login."]));
        })
    }, defaultDelay);
  }
}

export function logout(done) {
  return dispatch => {
    dispatch(_userLoading());
    setTimeout(() => {
      NodeAuth.User.logout();
      dispatch(_userLoggedOut());
      done()
    }, defaultDelay)
  }
}

export function queryStore(key, conditions, options = { per_page: 50, page: 1 }) {
  return dispatch => {
    dispatch(_queryingStore(true));
    NodeAuth.User.queryStore(key, conditions, options)
      .then(res => {
        dispatch(_queryingStore(false));
        if(res.success) {
          let tickets = [];

          res.data[key].forEach(ticketGroup => {
            ticketGroup.forEach(ticket => {
              tickets.push(ticket);
            })
          })
          dispatch(setTickets(tickets, res.data.total_pages));
        }
        else {
          if(typeof res.data.message === "string")
            return dispatch(_queryingStore(false, res.data.message));
          if(typeof res.data.message === "object" && res.data.message.code)
            return dispatch(_queryingStore(false, "Unauthorized access, try clear your local storage"));
          
            return dispatch(_queryingStore(false, "Something went wrong!"));
        }
      })
      .catch(err => {
        dispatch(_queryingStore(false, "An error occured while querying tickets"));
        console.error(err);
      })
  }
}

export function clearErrors() {
  return dispatch => dispatch(_clearErrors())
}

function _userErrors(errors) {
  return {
    type: types.USER_ERRORS,
    errors
  }
}

function _userLoggedIn({ username, avatar }) {
  return {
    type: types.USER_LOGIN,
    username,
    avatar
  }
}

function _userLoggedOut() {
  return {
    type: types.USER_LOGOUT
  }
}

function _userLoading() {
  return {
    type: types.USER_LOADING
  }
}

function _queryingStore(queryingStore, error) {
  return {
    type: types.USER_QUERYING_STORE,
    queryingStore,
    error
  }
}

function _clearErrors() {
  return {
    type: types.CLEAR_USER_ERRORS
  }
}